import { useState, type ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./auth";

/** App-wide providers: server-state cache + auth session. */
export function AppProviders({ children }: { children: ReactNode }) {
  // One QueryClient per app instance. Conservative defaults: don't refetch on
  // window focus (a control plane, not a live feed); surface errors to the UI.
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { refetchOnWindowFocus: false, retry: 1, staleTime: 30_000 },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>{children}</AuthProvider>
    </QueryClientProvider>
  );
}
